import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import s from './FolderCardFooter.scss';
const FolderCardFooter = ({ folder , className , totalDeviationCount , isLocked , statsClassName , withCommentsCount , withPremiumShownNextToTitle , withPrice , oneLineDescription , showCountsWithoutCaptions , hideStats , children , t  })=>{
    var _folder_premiumFolderData;
    const isPaid = ((_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.type) === 'paid';
    const withSubscribersCount = isPaid;
    const { formattedDollarPrice  } = normalizePremiumFolderData(folder.premiumFolderData);
    const renderStats = ()=>{
        var _folder_premiumFolderData, _folder_premiumFolderData1;
        /*#__PURE__*/ return React.createElement("div", {
            className: classnames(s['stats'], statsClassName)
        }, showCountsWithoutCaptions ? totalDeviationCount : t('folderCard.stats.artworks', {
            count: totalDeviationCount
        }), withCommentsCount && !withSubscribersCount && /*#__PURE__*/ React.createElement(React.Fragment, null, ' | ', showCountsWithoutCaptions ? folder.commentCount : t('folderCard.stats.comments', {
            count: folder.commentCount
        })), withSubscribersCount && /*#__PURE__*/ React.createElement(React.Fragment, null, ' | ', showCountsWithoutCaptions ? (_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.numSubscribers : t('folderCard.stats.subscribers', {
            count: (_folder_premiumFolderData1 = folder.premiumFolderData) === null || _folder_premiumFolderData1 === void 0 ? void 0 : _folder_premiumFolderData1.numSubscribers
        })));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], oneLineDescription && s['one-line-description'], !hideStats && s['with-stats'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, withPremiumShownNextToTitle && /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
        size: IconSize.SMALL,
        className: s['premium-icon'],
        premiumFolderData: folder.premiumFolderData
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: s['folder-name'],
        title: folder.name
    }, folder.name), isLocked && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('folderCard.locked'),
        usePortal: true
    }, /*#__PURE__*/ React.createElement(LockIcon, {
        className: s['lock-icon'],
        size: IconSize.SMALLER,
        condensed: true
    })), withPrice && isPaid && /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formattedDollarPrice)), !hideStats && renderStats()), children);
};
export default withTranslation()(FolderCardFooter);
